﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

var facebook = require('../../../event/helper/facebook');
import * as Entities_Empty from '../../../lib/entities/empty';

export default Marionette.LayoutView.extend({
    html : function () {
        return '<div id="empty"> <div id="container" style="padding: 0px 0px 0px 0px" class="container-fluid"> <div id="spin" class="row"> <div class="col-xs-12 col-md-12"> <div style="text-align:center"> <i class="fa fa-cog fa-spin" style="font-size:110px; color:#e74c3c"></i> </div> <h4 class="text-center" data-backdrop="static"><%= EventSpinText %></h4> </div> </div> <div class="row"> <div class="col-xs-12 col-md-12">  </div> </div> <div class="row"> <div class="col-xs-12 col-md-12">  </div> </div> <div class="row" style="margin: 0px 0px 0px 0px"> <div class="col-xs-12 col-md-12"> <div id="formData"></div> </div> </div> <div class="row"> <div class="col-xs-12 col-md-12">  </div> </div> <div class="row" id="divEvents4us_header" style="display:none"> <div class="col-xs-12 col-md-12"> <hr> </div> </div> <div class="row" id="divEvents4us_1" style="display:none"> <div class="col-xs-12 col-md-12"> <p style="text-align:center"><%= CopyrightText01 %><strong><a href="#about"><%= CopyrightText02 %></a></strong><%= CopyrightText03 %></p> </div> </div> <div class="row clearfix" id="divFacebook" style="display:none"> <div class="column full center"> <div style="margin:1em 0 2.5em"> <a id="btnFacebook" style="display:none" title="<%= Facebook_title %>" class="btn btn-facebook"><i class="fa fa-facebook"></i> <%= Facebook_text %></a> <a id="btnEvents4us" style="display:none" title="<%= Events4us_title %>" class="btn btn-events4us"><span class="events4us"></span> <%= Events4us_text %></a> </div> </div> </div> </div> </div>';
        //return '<div id="empty"> <%= Events4us_text %></div>';
    },
    getTemplate: function () {
        //return this.template({ model: this.model.toJSON() });
        return _.template(this.template);
    },
    setupModel : function () {
        this.model = new Entities_Empty.Model();

        //var srcWebpageImageUrl = 'testur';
        //if (srcWebpageImageUrl.length > 0) {
        //    this.model.attributes.WebpageImageUrl = 'testur';
        //} else {
        //    this.model.attributes.WebpageImageUrl = 'testur';
        //}
        var srcQRCodeImageUrl = 'testur';
        if (srcQRCodeImageUrl.length > 0) {
            this.model.attributes.QRCodeImageUrl = 'testur';
        } else {
            this.model.attributes.QRCodeImageUrl = 'testur';
        }
            this.model.attributes.CopyrightText01 = resources['X100020'];
            this.model.attributes.CopyrightText02 = resources['X100021'];
            this.model.attributes.CopyrightText03 = resources['X100022'];

        this.model.attributes.Events4us_text = resources['X100908'];
        this.model.attributes.Events4us_title = resources['X100475'];
        this.model.attributes.Facebook_text = resources['X100471'];
        this.model.attributes.Facebook_title = resources['X100472'];
        this.model.attributes.EventSpinText = resources['X100019'];
    },
    initialize: function () {
        this.app = this.options.app;
        this.setupModel();
        this.template = this.html();
    },
    ui: {
        'divFacebook' : '#divFacebook',
        'divEvents4us_1' : '#divEvents4us_1',
        'btnFacebook' : '#btnFacebook',
        'btnEvents4us' : '#btnEvents4us',
        'divEvents4us_header' : '#divEvents4us_header'
    },
    events: {
        'click @ui.btnFacebook': 'btnFacebookClick',
        'click @ui.btnEvents4us': 'btnEvents4usClick'
    },
    onRender: function () {
        //return $(template).tmpl(this.model.toJSON());
        //this.getTemplate(this.model.toJSON());

        var showHeader = false;

        switch (1) {
            case 0 : this.ui.divFacebook.show(); this.ui.btnFacebook.show(); showHeader = true; break;
            case 1 : 
                this.ui.divFacebook.show(); 
                this.ui.btnFacebook.show(); 
                showHeader = true; 
             break;
        }

        switch (1) {
            case 0 : break;
            case 1 : this.ui.divFacebook.show(); this.ui.btnEvents4us.show(); this.ui.divEvents4us_1.show(); showHeader = true; break;
        }
    },
    btnFacebookClick: function (event) {
    },
    btnEvents4usClick: function (event) {
        
    }
}, Backbone.Radio.Requests);

